export default __webpack_public_path__ + "static/media/4.ddab0856.png";